import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from '@/components/Layout';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { LoginPage } from '@/pages/LoginPage';
import { ForgotPasswordPage } from '@/pages/ForgotPasswordPage';
import { ResetPasswordPage } from '@/pages/ResetPasswordPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { OperativyListPage } from '@/pages/OperativyListPage';
import { OperativaDetailPage } from '@/pages/OperativaDetailPage';
import { MechanizacePage } from '@/pages/MechanizacePage';
import { CinnostiPage } from '@/pages/CinnostiPage';
import { ZamestnanciPage } from '@/pages/ZamestnanciPage';
import { MaterialPage } from '@/pages/MaterialPage';
import { ZastupyPage } from '@/pages/ZastupyPage';
import { UzivatelePage } from '@/pages/UzivatelePage';
import { ProfilPage } from '@/pages/ProfilPage';
import { AuditPage } from '@/pages/AuditPage';
import { NovinkyPage } from '@/pages/NovinkyPage';
import { DevelopPage } from '@/pages/DevelopPage';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <Layout>
              <Routes>
                <Route path="/" element={<DashboardPage />} />
                <Route path="/operativy" element={<OperativyListPage />} />
                <Route path="/operativy/:id" element={<OperativaDetailPage />} />
                <Route path="/mechanizace" element={<MechanizacePage />} />
                <Route path="/cinnosti" element={<CinnostiPage />} />
                <Route path="/zamestnanci" element={<ZamestnanciPage />} />
                <Route path="/material" element={<MaterialPage />} />
                <Route path="/zastupy" element={<ZastupyPage />} />
                <Route path="/uzivatele" element={<UzivatelePage />} />
                <Route path="/audit" element={<AuditPage />} />
                <Route path="/novinky" element={<NovinkyPage />} />
                <Route path="/profil" element={<ProfilPage />} />
                <Route path="/develop" element={<DevelopPage />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Layout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}
